// src/services/LangStore.ts
import config from '../../../locale_config.json'

interface LocaleConfig {
  app?: string
  shared?: {
    modules: string[]
    useShared?: boolean
  }
  microApps?: {
    [key: string]: {
      modules: string[]
      useShared?: boolean
    }
  }
  modules?: string[]
}

export class LangStore {
  private static moduleDependencies = new Map<string, string[]>()
  private static AllModules = new Array<string>()
  private static supportLangs = ['zh-CN', 'en-US', 'zh-TW']

  /**
   * 初始化模块依赖关系（应用启动时调用）
   */
  static initialize() {
    const appDepModuleCollections: string[] = []

    // 预构建模块依赖图
    if (config.microApps) {
      Object.entries(config.microApps).forEach(([appName, appConfig]) => {
        const sharedModules = config.shared?.modules || []
        const shouldUseShared =
          appConfig.useShared ?? config.shared?.useShared ?? true

        this.moduleDependencies.set(appName, [
          ...(shouldUseShared ? sharedModules : []),
          ...appConfig.modules,
        ])

        appDepModuleCollections.push(...appConfig.modules)
      })
    }

    this.AllModules = [
      ...(config.shared?.modules || []),
      ...appDepModuleCollections,
    ]
  }

  /**
   * 获取应用依赖的所有模块（带缓存）
   */
  static getAppModules(appName: string): string[] {
    if (!this.moduleDependencies.has(appName)) {
      // 返回共享模块
      return [...this.getSharedModules()]
    }
    return [...this.moduleDependencies.get(appName)!] // 返回副本避免外部修改
  }

  /**
   * 获取所有共享模块（静态不可变）
   */
  static getSharedModules(): string[] {
    return [...(config.shared?.modules || [])] // 防御性拷贝
  }

  /**
   * 获取所有支持的语言
   */
  static getSupportLangs(): string[] {
    return [...this.supportLangs]
  }

  /**
   * 更新支持的语言列表
   */
  static setSupportLangs(langs: string[]): void {
    if (Array.isArray(langs) && langs.length > 0) {
      this.supportLangs = [...langs]
    }
  }

  static getAllModules(): string[] {
    return [...this.AllModules]
  }

  /**
   * 检查模块是否被至少一个应用依赖
   */
  static isModuleUsed(module: string): boolean {
    return Array.from(this.moduleDependencies.values()).some((deps) =>
      deps.includes(module),
    )
  }
}
